export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '录单时间',
		align: 'center',
		dataIndex: 'createTime',
		key: 'createTime',
		scopedSlots: { customRender: 'createTime' },
	},
	{
		title: '订单号',
		align: 'center',
		dataIndex: 'orderNo',
		key: 'orderNo',
	},
	{
		title: '报案号',
		align: 'center',
		dataIndex: 'caseNo',
		key: 'caseNo',
	},
	{
		title: '调解类型',
		align: 'center',
		dataIndex: 'taskType',
		key: 'taskType',
		scopedSlots: { customRender: 'taskType' },
	},
	{
		title: '车主姓名',
		align: 'center',
		dataIndex: 'ownerName',
	},
	{
		title: '车主电话',
		align: 'center',
		dataIndex: 'ownerPhone',
	},
	{
		title: '调解地区',
		align: 'center',
		dataIndex: 'location',
	},
	{
		title: '任务状态',
		align: 'center',
		dataIndex: 'orderStatus',
		scopedSlots: { customRender: 'orderStatus' },
	},
	{
		title: '操作',
		align: 'center',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
